import { render } from "./editsalesreturns.vue?vue&type=template&id=4ca6a9f6"
import script from "./editsalesreturns.vue?vue&type=script&lang=js"
export * from "./editsalesreturns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__